import React, { useState, useEffect } from "react"
import logo from './logo.svg';
import './App.css';
import 'antd/dist/antd.css';
import {
  createBrowserRouter,
  RouterProvider,
  Route,
} from "react-router-dom";
import { Router, SecureRouter, FourZeroFour } from "./routes"


function App() {
  const [islogin, setislogin] = useState(true)
  return (
    <>
      <RouterProvider router={islogin !== true ? Router : SecureRouter} />
    </>
  );
}

export default App;
